import { useMutation, useQueryClient } from '@tanstack/react-query';
import morphism from 'morphism';

import { QUERY_KEYS } from '@hero/constants';
import { recognitionRequest } from '@hero/schemas';
import { recognitionServices } from '@hero/services';

export const useRecognitionSharePreview = ({ recognitionCode, options = {} } = {}) => {
  const queryClient = useQueryClient();

  return useMutation(formData => recognitionServices.share(recognitionCode, formData), {
    onSuccess: (_data, variables) => {
      queryClient.setQueryData([QUERY_KEYS.useGetRecognitionKey, recognitionCode], old => ({
        ...old,
        ...morphism(recognitionRequest.update, variables)
      }));
    },
    ...options
  });
};
